import { motion } from "framer-motion";

const FOUNDATION = "/foundation-bg.png";

const approach = [
  "Outcome-driven, never activity-driven",
  "Strategic — and execution-honest",
  "Fast, clear and commercially grounded",
];

const why = [
  "30+ years of global product leadership",
  "Deep operator's view across ConTech, SaaS and AI",
  "Proven track record linking product to revenue and valuation",
  "Trusted advisor to CEOs, founders and boards",
];

export const HowAndWhy = () => {
  return (
    <section
      data-testid="how-why-section"
      className="relative py-20 sm:py-28 md:py-40 overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-50"
        style={{ backgroundImage: `url(${FOUNDATION})` }}
      />
      <div className="absolute inset-0 bg-[#050505]/90" />

      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-6 md:px-12">
        <div className="grid grid-cols-12 gap-10 md:gap-12">
          {/* How I Work */}
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-[#C5A880]" />
              <span className="text-[11px] font-semibold tracking-[0.3em] uppercase text-[#C5A880]">
                How I Work / 06
              </span>
            </div>
            <h2
              data-testid="how-heading"
              className="font-serif-display text-3xl sm:text-4xl md:text-5xl font-light leading-[1.1] md:leading-[1.05] tracking-tight text-[#F5F5F0] mb-6 sm:mb-8"
            >
              A thought partner to the{" "}
              <em className="italic text-[#C5A880]">CEO</em> — focused on the
              few decisions that move the company.
            </h2>
            <p className="text-[15px] sm:text-base md:text-lg text-[#A3A39A] leading-relaxed mb-8 sm:mb-10">
              I operate as an extension of the executive team. Not another
              voice in the room — the one helping you cut through to the call
              that actually matters.
            </p>
            <ul className="space-y-4 sm:space-y-5 border-t border-[#1a1a1a] pt-6 sm:pt-8">
              {approach.map((a, i) => (
                <motion.li
                  key={a}
                  initial={{ opacity: 0, x: -8 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="flex items-start gap-4 sm:gap-5 group"
                >
                  <span className="font-serif-display text-2xl sm:text-3xl text-[#C5A880] leading-none flex-shrink-0">
                    {i + 1}.
                  </span>
                  <span className="font-serif-display text-xl sm:text-2xl md:text-3xl font-light text-[#F5F5F0] group-hover:text-[#C5A880] transition-colors">
                    {a}
                  </span>
                </motion.li>
              ))}
            </ul>
          </div>

          {/* Why Work With Me */}
          <div className="col-span-12 md:col-span-6 md:border-l md:border-[#1a1a1a] md:pl-12">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-[#C5A880]" />
              <span className="text-[11px] font-semibold tracking-[0.3em] uppercase text-[#C5A880]">
                Why Work With Me / 07
              </span>
            </div>
            <h2
              data-testid="why-heading"
              className="font-serif-display text-3xl sm:text-4xl md:text-5xl font-light leading-[1.1] md:leading-[1.05] tracking-tight text-[#F5F5F0] mb-8 sm:mb-10"
            >
              Built on three decades of{" "}
              <em className="italic text-[#C5A880]">earned</em> judgment.
            </h2>

            <div className="border-t border-[#1a1a1a]">
              {why.map((w, i) => (
                <motion.div
                  key={w}
                  initial={{ opacity: 0, y: 8 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.06 }}
                  className="flex items-baseline gap-4 sm:gap-6 py-4 sm:py-5 border-b border-[#1a1a1a]"
                  data-testid={`why-item-${i}`}
                >
                  <span className="text-[11px] tracking-[0.25em] text-[#C5A880] flex-shrink-0">
                    0{i + 1}
                  </span>
                  <p className="text-[#F5F5F0] text-[15px] sm:text-base md:text-lg leading-relaxed">
                    {w}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowAndWhy;
